import styled from 'styled-components';
import { media } from '@bitcoin-portal/bitcoincom-pkg-theme';
import Section from '@bitcoin-portal/bitcoincom-pkg-components/dist/Section';

export const StyledSection = styled(Section)`
  order: 8;
  background: #ffffff !important;
  padding: 40px 0px !important;
  margin: 0px !important;

  ${media.md`
    padding: 80px 0px 60px !important;
  `}

  ${media.xl`
    padding: 100px 0px !important;
  `}
`;

export const StyledContentBlock = styled.div`
  max-width: 1440px;
  padding: 0px !important;
  margin: auto;
`;

export const MainContainer = styled.div`
  padding: 0px 20px !important;

  ${media.md`
    padding: 0px 60px !important;
  `}

  ${media.xl`
    padding: 0px 80px !important;
  `}
`;

export const MainWrapper = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 20px;
  align-self: stretch;
`;

export const FirstRowWrapper = styled.div`
  display: flex;
  justify-content: start;
  align-items: start;
  flex-direction: column;
  width: 100%;
  gap: 20px;

  ${media.lg`
    flex-direction: row;
  `}
`;

export const BlueSection = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  background: #4169e1;
  width: calc(100% - 40px);
  height: auto;
  padding: 20px;
  border-radius: 10px;

  ${media.md`
    border-radius: 20px;
  `}

  ${media.lg`
    width: calc(59% - 50px);
    height: 245px;
    padding: 20px;
  `}

  ${media.xl`
    width: calc(59% - 110px);
    border-radius: 20px;
    padding: 50px;
  `}
`;

export const ContentWrapper = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  gap: 50px;
`;

export const TextWrapper = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 25px;
`;

export const Title = styled.h3`
  color: #ffffff;
  font-family: 'Elza Condensed', sans-serif;
  font-size: 52px;
  font-weight: 900;
  line-height: 87%;
  letter-spacing: -1.04px;
  text-align: center;
  text-transform: uppercase;
  margin: 0px;

  ${media.md`
    font-size: 70px;
    font-weight: 900;
    line-height: 85%;
    letter-spacing: -1.4px;  
  `}

  ${media.lg`
    font-size: 54px;
    font-weight: 900;
    line-height: 85%;
    letter-spacing: -1.4px;
  `}

  ${media.xl`
    font-size: 70px;
    font-weight: 900;
    line-height: 85%;
    letter-spacing: -1.4px;
  `}
`;

export const Text = styled.p`
  color: #ffffff;
  font-family: 'Satoshi Variable Medium', sans-serif;
  font-size: 18px;
  font-weight: 500;
  line-height: 140%;
  text-align: center;
  margin: 0px;

  ${media.md`
    font-size: 20px;
    font-weight: 500;
    line-height: 130%;  
  `}

  ${media.lg`
    font-size: 18px;
    font-weight: 500;
    line-height: 123%;  
  `}

  ${media.xl`
    font-size: 22px;
    font-weight: 500;
    line-height: 113%;  
  `}
`;

export const ButtonWrapper = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  width: 100%;
  gap: 20px;

  ${media.lg`
    flex-direction: row;
    width: unset;
    gap: 10px;
  `}
`;

export const SignUpButton = styled.a`
  display: flex;
  justify-content: center;
  align-items: center;
  width: calc(100% - 56px);
  background: #ff9500;
  border-radius: 116.162px;
  padding: 14px 28px;
  text-decoration: none;
  gap: 9.293px;
  height: 20px;
  color: #1c1c1c;
  font-family: 'Satoshi Variable Medium', sans-serif;
  font-size: 20px;
  font-weight: 500;
  line-height: 110%;
  text-align: center;
  cursor: pointer;

  position: relative;
  overflow: hidden;
  z-index: 1;
  transition: background 0.3s ease, color 0.3s ease;

  &:hover {
    background: #ff7c18;
  }

  .ripple {
    position: absolute;
    border-radius: 50%;
    transform: scale(0);
    animation: ripple-animation 1.5s ease-out;
    background-color: rgba(204, 85, 0, 0.6);
    pointer-events: none;
    z-index: 0;
  }

  @keyframes ripple-animation {
    to {
      transform: scale(4);
      opacity: 0;
    }
  }

  ${media.md`
    width: 144px;
  `}

  ${media.lg`
    width: fit-content;
  `}

  ${media.xl`
    width: 197px;
    height: 28px;
  `}
`;

export const GetAppButton = styled.a`
  display: flex;
  justify-content: center;
  align-items: center;
  width: calc(100% - 56px);
  text-decoration: none;
  background: #ffffff;
  border-radius: 116.162px;
  padding: 14px 28px;
  gap: 9.293px;
  height: 20px;
  color: #1c1c1c;
  font-family: 'Satoshi Variable Medium', sans-serif;
  font-size: 20px;
  font-weight: 500;
  line-height: 110%;
  text-align: center;
  cursor: pointer;

  position: relative;
  overflow: hidden;
  z-index: 1;
  transition: background 0.3s ease, color 0.3s ease;

  &:hover {
    background: #f0f0f5;
  }

  .ripple {
    position: absolute;
    border-radius: 50%;
    transform: scale(0);
    animation: ripple-animation 2s ease-out;
    background-color: rgba(255, 255, 255, 0.4);
    pointer-events: none;
  }

  @keyframes ripple-animation {
    to {
      transform: scale(4);
      opacity: 0;
    }
  }

  ${media.md`
    width: 144px;
  `}

  ${media.lg`
    width: fit-content;
  `}

  ${media.xl`
    height: 28px;
    width: 197px;
  `}
`;

export const BitcoinSection = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  background: #f0f0f5;
  width: 100%;
  height: 187px;
  border-radius: 10px;

  ${media.md`
    height: 435px;
    border-radius: 20px;
  `}

  ${media.lg`
    width: calc(41% - 10px);
    height: 285px;
  `}

  ${media.xl`
    height: 345px;
  `}
`;

export const BitcoinImage = styled.img`
  width: 100%;
  height: 100%;
  border-radius: 10px;

  ${media.md`
    border-radius: 20px;
  `}
`;

export const SecondRowWrapper = styled.div`
  display: flex;
  justify-content: start;
  align-items: start;
  flex-direction: column;
  width: 100%;
  gap: 20px;

  ${media.lg`
    flex-direction: row;
  `}
`;

export const DesktopImageSection1 = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  background: #faf2e8;
  width: 100%;
  height: 144px;
  border-radius: 10px;

  ${media.md`
    height: 332px;
    border-radius: 20px;
  `}

  ${media.lg`
    width: calc(59% - 10px);
    height: 319px;
  `}

  ${media.xl`
    height: 379px;
  `}
`;

export const DesktopImage1 = styled.img`
  width: 100%;
  height: 100%;
  border-radius: 10px;

  ${media.md`
    border-radius: 20px;
  `}
`;

export const DesktopImageSection2 = styled.div`
  position: relative;
  background: #ff9500;
  width: 100%;
  height: 202px;
  border-radius: 10px;
  padding: 20px 0px 0px;

  ${media.md`
    height: 480px;
    border-radius: 20px;
  `}

  ${media.lg`
    width: calc(41% - 10px);
    height: 299px;
  `}

  ${media.xl`
    height: 359px;
  `}
`;

export const AppTitle = styled.p`
  color: #ffffff;
  font-family: 'Elza Condensed', sans-serif;
  font-size: 70px;
  font-weight: 900;
  line-height: 87%;
  letter-spacing: -1.389px;
  text-transform: uppercase;
  text-align: center;
  margin: 0px;

  ${media.md`
    font-size: 160px;
    font-weight: 900;
    line-height: 85%;
    letter-spacing: -3.234px;  
  `}

  ${media.lg`
    font-size: 90px;
    font-weight: 900;
    line-height: 87%;
    letter-spacing: -4px;  
  `}

  ${media.xl`
    font-size: 130px;
    font-weight: 900;
    line-height: 85%;
    letter-spacing: -4.6px;
  `}
`;

export const DesktopImage2 = styled.img`
  position: absolute;
  width: 214px;
  height: auto;
  bottom: 0px;
  left: 50%;
  transform: translateX(-50%);

  ${media.md`
    width: 510px;
  `}

  ${media.lg`
    width: 330px;
  `}

  ${media.xl`
    width: 375px;
  `}
`;
